import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpS = createBreakpoint('s');

export const mainCls = 'skBox';

export default {
  [`${mainCls}--boxed`]: {
    border: '1px solid #e4e4e4',
  },
  [`${mainCls}--nomobile`]: {
    display: 'none',
    [brpS]: {
      display: 'flex',
    },
	},
};
